var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.alertVisible)?_c('el-alert',_vm._g(_vm._b({staticClass:"alert-mobile",attrs:{"type":"warning","center":""}},'el-alert',_vm.$attrs,false),_vm.$listeners),[[_vm._v("是否切换为移动端网页？"),_c('button',{on:{"click":_vm.viewMobile}},[_vm._v("立即切换")])]],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }